import { render, staticRenderFns } from "./ui-color.vue?vue&type=template&id=f68aa064&scoped=true&"
import script from "./ui-color.vue?vue&type=script&lang=js&"
export * from "./ui-color.vue?vue&type=script&lang=js&"
import style0 from "./ui-color.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ui-color.vue?vue&type=style&index=1&id=f68aa064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68aa064",
  null
  
)

export default component.exports